function r(f) {
  /in/.test(document.readyState) ? setTimeout(() => r(f), 9) : f();
}

r(function () {
  // Update captions
  const updateCaption = (selector) => {
    document.querySelectorAll(selector).forEach((element) => {
      element.textContent = "Usually ready in 2-4 Weeks for bulky items";
    });
  };

  const subheader = document.querySelector(".subheader-ext");

  // Add scroll event listener to the window
  window.addEventListener("scroll", () => {
    if (window.scrollY > 350) {
      // Hide the subheader by removing the class
      subheader.classList.remove("showing");
    } else {
      // Show the subheader by adding the class
      subheader.classList.add("showing");
    }
  });

  updateCaption(".pickup-availability-info .caption");
  updateCaption(".pickup-availability-list .caption-large");
  updateCaption("._1x52f9si");

  // Hamburger menu toggle
  const element = document.getElementById("che-hamburger-menu");
  const overlay = document.getElementById("che-menu-overlay");
  const body = document.body;

  if (element && overlay) {
    element.onclick = (e) => {
      e.preventDefault();
      const isActive = element.classList.toggle("active");
      overlay.classList.toggle("active", isActive);
      overlay.classList.toggle("remove", !isActive);
      body.classList.toggle("noscroll", isActive);
    };
  }

  // Show elements by ID
  const elementsToShow = [
    "apps-che-category-slider-wrapper",
    "che-product-slider-fridges",
    "che-product-slider-outdoor-wrapper",
    "che-home-slider-wrapper",
    "che-mouse-over-slider-container",
    "che-simple-image-banner",
    "gazebo-product-slider-wrapper",
  ];

  elementsToShow.forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.style.display = "block";
  });

  // Update background image
  const collection = document.getElementsByClassName(
    "che-mouse-over-src-slider"
  );
  if (collection.length > 0) {
    const dataSrc = collection[0].getAttribute("data-src");
    const mouseOverMainElement = document.getElementById(
      "che-mouse-over-slider"
    );
    if (mouseOverMainElement && dataSrc) {
      mouseOverMainElement.style.backgroundImage = `url('${dataSrc}')`;
      mouseOverMainElement.style.backgroundPosition = "center";
      mouseOverMainElement.style.backgroundRepeat = "no-repeat";
      mouseOverMainElement.style.backgroundSize = "cover";
    }
  }

  // Initialize sliders
  const initSlider = (container, itemsConfig) => {
    return tns({
      container,
      items: itemsConfig.default,
      autoplay: itemsConfig.autoplay || false,
      controlsPosition: "bottom",
      autoplayButtonOutput: false,
      arrowKeys: true,
      controls: false,
      nav: itemsConfig.nav || false,
      autoplayButton: false,
      responsive: itemsConfig.responsive,
    });
  };

  const slidersConfig = [
    {
      container: ".che-mouse-over-slider",
      items: 4,
      autoplay: true,
      responsive: {
        200: { items: 1 },
        640: { items: 2 },
        900: { items: 4 },
        1200: { items: 4 },
      },
    },
    {
      container: ".apps-che-category-slider",
      items: 7,
      responsive: {
        100: { items: 3 },
        640: { items: 3 },
        700: { items: 4 },
        900: { items: 5 },
        1200: { items: 7 },
      },
    },
    {
      container: ".che-product-slider-fridge",
      items: 7,
      responsive: {
        300: { items: 2 },
        700: { items: 4 },
        900: { items: 5 },
        1200: { items: 5 },
      },
    },
    {
      container: ".che-home-slider-container",
      items: 1,
      speed: 4000,
      autoplayTimeout: 7000,
      autoplay: true,
      autoHeight: true,
      mouseDrag: true,
      nav: true,
    },
    {
      container: ".che-simple-slider-container",
      items: 1,
      autoplay: true,
      autoHeight: true,
      mouseDrag: true,
    },
    {
      container: ".che-product-slider-outdoor",
      items: 7,
      responsive: {
        300: { items: 2 },
        700: { items: 4 },
        900: { items: 4 },
        1200: { items: 4 },
        1300: { items: 5 },
      },
    },
    {
      container: ".gazebo-product-slider-outdoor",
      items: 7,
      responsive: {
        300: { items: 2 },
        700: { items: 4 },
        900: { items: 4 },
        1200: { items: 4 },
        1300: { items: 5 },
      },
    },
  ];

  const sliders = slidersConfig.map((config) =>
    initSlider(config.container, config)
  );

  // Slider controls
  const setSliderControls = (prevId, nextId, sliderIndex) => {
    const prev = document.getElementById(prevId);
    const next = document.getElementById(nextId);

    if (prev && next) {
      prev.onclick = (e) => {
        e.preventDefault();
        sliders[sliderIndex].goTo("prev");
      };
      next.onclick = (e) => {
        e.preventDefault();
        sliders[sliderIndex].goTo("next");
      };
    }
  };

  setSliderControls("che-prev", "che-next", 1);
  setSliderControls("che-br-slider-arrow-left", "che-br-slider-arrow-right", 2);
  setSliderControls("che-ok-slider-arrow-left", "che-ok-slider-arrow-right", 5);
  setSliderControls(
    "gazebo-ok-slider-arrow-left",
    "gazebo-ok-slider-arrow-right",
    6
  );

  // Alphabet container
  const cac = document.getElementById("che-alphabet-container");
  if (cac) {
    const alphabet = [
      "#",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
    ];
    let li = "";
    alphabet.forEach((letter) => {
      li += `<li class=${letter}><span onmouseover="getData('${letter}')">${letter}</span><div class="che-aphabet-list-container" id="che-aphabet-list-container-${letter}"></div></li>`;
    });
    cac.innerHTML = `<ul class="che-alphabet-list">${li}</ul>`;
  }
});

function getData(letter) {
  const listContainer = document.getElementById("che-data-ventors-list");
  const list = listContainer ? listContainer.getElementsByTagName("li") : [];
  const brandsListContainer = document.getElementById(
    `che-aphabet-list-container-${letter}`
  );
  if (!brandsListContainer) return;

  brandsListContainer.innerHTML = "";
  let selected = "";

  if (letter === "#") {
    const selectionList = [
      ".",
      "#",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
    ];
    selectionList.forEach((x) => {
      for (let i = 0; i < list.length; i++) {
        const a = list[i].getElementsByTagName("a")[0];
        const txtValue = a.textContent || a.innerText;
        if (txtValue.toUpperCase().startsWith(x)) {
          selected += `<li><a href="${a.getAttribute("href")}">${
            a.innerText
          }</a></li>`;
        }
      }
    });
  } else {
    for (let i = 0; i < list.length; i++) {
      const a = list[i].getElementsByTagName("a")[0];
      const txtValue = a.textContent || a.innerText;
      if (txtValue.toUpperCase().startsWith(letter)) {
        selected += `<li><a href="${a.getAttribute("href")}">${
          a.innerText
        }</a></li>`;
      }
    }
  }

  brandsListContainer.innerHTML = `<ul class="brand-list-wrapper">${selected}</ul>`;
}

function getAttr(src) {
  const mouseOverMainElement = document.getElementById("che-mouse-over-slider");
  if (mouseOverMainElement) {
    mouseOverMainElement.style.backgroundImage = `url('${src}')`;
    mouseOverMainElement.style.backgroundPosition = "center";
    mouseOverMainElement.style.backgroundRepeat = "no-repeat";
    mouseOverMainElement.style.backgroundSize = "cover";
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const widget = document.getElementById("fc_frame");
  if (widget) {
    widget.style.display = "none"; // Hide it on page load
  }

  // For dynamically injected widgets
  const observer = new MutationObserver(() => {
    const dynamicWidget = document.getElementById("fc_frame");
    if (dynamicWidget) {
      dynamicWidget.style.display = "none";
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
});

